import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 8h1v8","key":"svg-0"}],["path",{"d":"M6 8v3a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M10 8v8","key":"svg-2"}]]

/**
 * IconNumber41Small
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbnVtYmVyLTQxLXNtYWxsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNSA4aDF2OCIgLz4KICA8cGF0aCBkPSJNNiA4djNhMSAxIDAgMCAwIDEgMWgzIiAvPgogIDxwYXRoIGQ9Ik0xMCA4djgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/number-41-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNumber41Small = createReactComponent('outline', 'number-41-small', 'Number41Small', __iconNode);

export default IconNumber41Small;